import React from 'react'
import { InputField } from '@enamelai/design-system'
import { IClinicNumber } from '@dataTypes/clinic.type'

interface SelectNumberProps {
  numberData: IClinicNumber
  handleChange: (field: string, value: string | boolean | null) => void
  nonPortableNumberHint: string | null
  validationErrors: { [key: string]: string }
}

const SelectNumber: React.FC<SelectNumberProps> = ({
  numberData,
  handleChange,
  nonPortableNumberHint,
  validationErrors,
}) => {
  const portabilityBlocked = !!validationErrors.is_portable
  const phoneHelperText = validationErrors.phone_number
    ? validationErrors.phone_number
    : portabilityBlocked
      ? nonPortableNumberHint
        ? `${nonPortableNumberHint} cannot be ported. Remove it or enter a different number.`
        : validationErrors.is_portable ||
          'A number cannot be ported. Input a new number or remove.'
      : 'All numbers must belong to the same carrier account'

  return (
    <div className="scp-pm-port-form">
      <InputField
        id="scp-pm-port-phone-numbers"
        variant="message"
        fullWidth
        rows={4}
        showCounter={false}
        label="Phone number(s) to port"
        value={numberData.phone_number}
        placeholder={`+1 (916) 555 1112\n+1 (916) 555 1113`}
        onChange={(event) => handleChange('phone_number', event.target.value)}
        error={!!validationErrors.phone_number || portabilityBlocked}
        helperText={phoneHelperText}
        onClear={() => handleChange('phone_number', '')}
      />
      <InputField
        variant="text"
        fullWidth
        label="Carrier"
        placeholder="Enter carrier name"
        value={numberData.phone_carrier || ''}
        onChange={(event) => handleChange('phone_carrier', event.target.value)}
        error={!!validationErrors.phone_carrier}
        helperText={validationErrors.phone_carrier}
        clearable={false}
      />
    </div>
  )
}

export default SelectNumber
